import styled from "styled-components"

type StyledProps = {
 $logoMargin?: string
  $columns?: string
}

export const Container = styled.div`
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.6rem;
  padding: 2rem;
  position: relative;
  width: 100%;
  display: grid;
  gap: 2rem;
    margin-bottom: 1rem;

  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    padding: 2rem 4rem 2rem;
  }
`

export const Label = styled.div`
  font-size: 1.2rem;
`

export const Title = styled.h2<StyledProps>`
  display: flex;
  align-items: center;
  margin-top: 1rem;

  svg {
    height: 2.4rem;
    margin: ${(p) => p.$logoMargin}
  }
`

export const Row = styled.div<StyledProps>`
  display: grid;
  grid-template-columns: 1fr;
  ${(p) => p.theme.mQ.MEDIA_MIN_LARGE} {
    grid-template-columns: ${p => p.$columns ?? "repeat(2, 1fr)"};
  }
 margin-bottom: 1rem;
`

export const StatusWrapper = styled.div`
    width: 14rem
`
